export const DEFAULT_SPOTIFY_PLAYLIST =
  'https://open.spotify.com/playlist/57H7ZS2ehR6ELKrlU7P9jq?si=8748bc9c5af449f8&pt=388e503aa57e52c84043284c09069247';
